import { render, staticRenderFns } from "./OverviewItem.vue?vue&type=template&id=56506ec7&"
import script from "./OverviewItem.vue?vue&type=script&lang=js&"
export * from "./OverviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports